export type TotalProductsSummaryProps = {
  totalNumberOfProducts: number;
  originalPrice?: number;
  estimatePrice?: number;
  type?: TotalProductsSummaryType;
  focusOrder?: number;
  focusId?: string;
};

export enum TotalProductsSummaryType {
  ON_LIGHT = 'on-light',
  ON_DARK = 'on-dark',
}
